import React from 'react'
import UpgradeToGetStarted from '../../../components/UpgradeToGetStarted/UpgradeToGetStarted'

const TimeSheetAprovals = () => {
  return (
    <div>
       <UpgradeToGetStarted
      imageSrc="./assets/images/timesheet/timesheetapprovals.png"
      imageAlt="Timesheet Approvals"
      heading="Timesheet approvals"
      description="Enable approvals for any team member — they’ll be prompted to submit timesheets after each pay period, and managers will be notified to review. Once approved, timesheets can be processed for payment automatically or manually."
      lockIconSrc="./assets/images/app-activity/insights/lock-icon.svg"
      promoText="Schedule a call with our sales team to discover more about Timesheet approvals."
      buttonText="Upgrade to get started"
      showTextContent={true}
    />
    </div>
  )
}

export default TimeSheetAprovals
